import {
  UNSET_AVATAR,
  UPLOADING_AVATAR,
  UPLOAD_AVATAR_ERROR,
  UPLOAD_AVATAR_SUCCESS,
} from '../actions';

const initialState = {
  avatarURL: '',
  error: false,
};

export default function reducer(state = initialState, action) {
  switch (action.type) {
    case UPLOAD_AVATAR_SUCCESS: {
      return {
        ...state,
        error: initialState.error,
        avatarURL: action.payload.avatarURL,
      };
    }
    case UPLOAD_AVATAR_ERROR: {
      return {
        ...state,
        avatarURL: initialState.avatarURL,
        error: action.error,
      };
    }
    case UPLOADING_AVATAR: {
      return {
        ...state,
        avatarURL: initialState.avatarURL,
        error: initialState.error,
      };
    }
    case UNSET_AVATAR: {
      return {
        ...state,
        avatarURL: '',
      };
    }
    default:
      return state;
  }
}
